import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/currency-converter-contents/TopicOne";

const CurrencyConverterContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Your Gateway to Real-Time Forex Rates</h2>
                <p>
                  The Pips Currency Converter delivers live exchange rates for
                  global currencies, helping you stay updated with real market
                  movements. Whether you’re planning a trade, managing
                  multi-currency portfolios, or simply checking conversions for
                  travel or transactions, this tool keeps you informed and
                  accurate. Updated in real time, it ensures you always work
                  with the most current market data. Its intuitive interface
                  makes comparing currency pairs fast and effortless. With The
                  Pips Currency Converter, you gain clarity and confidence in
                  every calculation you make.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Use Converter
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/currency_converter/currency_converter_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrencyConverterContentOne;
